import React from "react";

const OptionsImage = ({ image, size }) => {
  if (!image) return null;

  const sizeKey = size || "original_crop@450";

  // If just a URL string is passed in
  if (typeof image === "string") {
    return <img src={image} alt="" />;
  }

  // If a WP-style image object is passed in
  if (typeof image === "object") {
    const sizes = image.sizes || {};
    const imageUrl = sizes[sizeKey] || image.url;

    return <img src={imageUrl} alt={image.alt || ""} />;
  }

  return null;
};

export default OptionsImage;
